<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20">
    <el-row v-loading="isLoading" type="flex" justify="space-between" :gutter="20" class="mr-t5">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="120px" :rules="configRules">
                  <el-form-item label="장비명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objName">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="WAS 버전">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="filteredProducts" option-key="objtypeId, objProductId" property="objProductId" labelprop="objProductId">
                    </w-select-form>
                  </el-form-item>
                  <el-form-item label="WAS 종류">
                    <w-text-form :modifiable="false" :target="formData" property="objtypeName">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="IP 종류">
                    <w-text-form :modifiable="false" :target="formData" property="ipaddressApplytype">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="IPv4">
                    <w-text-form :modifiable="false" :target="formData" property="ipaddressIpv4">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="IPv6">
                    <w-text-form :modifiable="false" :target="formData" property="ipaddressIpv6">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="JAVA 버전">
                    <w-text-form :modifiable="false" :target="formData" property="javaVerInfo">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="WAS 기동시각">
                    <w-text-form :modifiable="false" :target="formData" property="wakeup">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objImportance">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">에이전트 정보</div>
              <div class="list form-list">
                <el-form ref="agentForm" :model="formData" label-width="120px">
                  <el-form-item label="에이전트 매니저명">
                    <w-text-form :modifiable="false" :target="formData" property="agentManagerName">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="에이전트 매니저 IP">
                    <w-text-form :modifiable="false" :target="formData" property="agentManagerIpaddress">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="에이전트 버전">
                    <w-text-form :modifiable="false" :target="formData" property="version">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId">
                      </el-option>
                    </el-select>
                    <span v-else> {{getObjManagerName(formData.objManagerIdMajor)}} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId">
                      </el-option>
                    </el-select>
                    <span v-else> {{getObjManagerName(formData.objManagerIdMinor)}} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Application Link 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="Link">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkWwwUrl">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="Application">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkAppPath">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag">
                    </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, isNil } from 'lodash';

import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import MsgUtil from '@/utils/message';

// api
import apmInfoAPI from '@/api/config/apm/apm-info';
import commonAPI from '@/api/config/common';

// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import WCheckgroupForm from '@/components/formeditor/CheckGroupFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import wManagerTreeForm from '@/components/formeditor/MgrTreeSelectEditor';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';

export default {
  name: 'WConfigStatus',
  props: {
    nodeParams: {
      type: Object,
    },
    activeTab: {
      type: String,
    },
  },
  components: {
    WTextForm,
    WNumberForm,
    WSelectForm,
    WCheckgroupForm,
    WCheckForm,
    wManagerTreeForm,
    WObjImportanceFormEditor,
  },
  data() {
    return {
      // Reject데이터
      isLoading: true,
      objOriginData: {},
      formData: {},
      managerList: [],
      basicInfoLoadFlag: false,
      objProductList: [],
    };
  },
  computed: {
    ...mapGetters(['configRules', 'rejectConfigEditing', 'saveConfigEditing']),
    params() {
      return {
        objId: this.nodeParams.objId,
      };
    },
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    filteredProducts() {
      return this.objProductList.filter((data) => data.objtypeId === this.formData.objtypeId);
    },
  },
  watch: {
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        if (this.params.objId) {
          if (!isNil(this.activeTab) && this.activeTab === 'WConfigStatus') {
            this.loadData();
          }
        }
      },
    },
    activeTab: {
      immediate: true,
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WConfigStatus') {
          // this.initData();
          if (this.params.objId) {
            this.loadData();
          }
        }
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.formData = Object.assign({}, this.objOriginData);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;

                  const updateData = {
                    objId: infoParams.objId,
                    objName: infoParams.objName,
                    ipaddressApplytype: infoParams.ipaddressApplytype,
                  };
                  if (infoParams.ipaddressApplytype === 'IPv4') {
                    updateData.ipaddressIpv4 = infoParams.ipaddressIpv4;
                  } else if (infoParams.ipaddressApplytype === 'IPv6') {
                    updateData.ipaddressIpv6 = infoParams.ipaddressIpv4;
                  }

                  // 수정된값들
                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      updateData[key] = formData[key];
                    });
                  }
                  if (this.objOriginData.objManagerIdMajor !== formData.objManagerIdMajor) {
                    updateData.objManagerIdMajor = formData.objManagerIdMajor;
                  }

                  if (this.objOriginData.objManagerIdMinor !== formData.objManagerIdMinor) {
                    updateData.objManagerIdMinor = formData.objManagerIdMinor;
                  }
                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  apmInfoAPI
                    .updateApmObjConfig(updateData)
                    .then((response) => {
                      this.$message(MsgUtil.getResultMsgData(action, target, response.data.success));
                      if (response.data.success) {
                        this.$store.dispatch('endConfigEdit');
                        this.loadData();
                      }
                    })
                    .catch(() => {
                      this.$message(MsgUtil.getResultMsgData(action, target, false));
                    });
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    getDateToString,
    loadData() {
      this.isLoading = true;
      this.objOriginData = {};
      // 최초 한번만 호출
      if (!this.basicInfoLoadFlag) {
        this.setBasicInfoData();
      }
      apmInfoAPI.getApmConfigInfoBasic(this.params).then((result) => {
        if (result.data.success) {
          const data = result.data.data;

          Object.assign(this.objOriginData, data);
          this.formData = Object.assign({}, this.objOriginData);
          this.$emit('setConfigData', this.formData);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    setBasicInfoData() {
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });
      commonAPI.getObjProductList({}).then((res) => {
        this.objProductList = res.data.data;
      });
      // this.basicInfoLoadFlag = true;
    },
    convertDate(value) {
      return isNil(value) ? EMPTY_TEXT : getDateToString(value);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: $chinagray;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/apm/configstatus/index.vue